import React from "react";

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
};
const ConfirmDeleteModal: React.FC<Props> = ({ onCancel, onConfirm }) => (
  <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
    <div className="bg-white p-8 rounded shadow-lg">
      <div className="mb-4 font-bold text-lg">Are you sure you want to delete this record?</div>
      <div className="flex gap-4 justify-end">
        <button className="bg-gray-200 px-4 py-1 rounded" onClick={onCancel}>Cancel</button>
        <button className="bg-red-600 text-white px-4 py-1 rounded" onClick={onConfirm}>Delete</button>
      </div>
    </div>
  </div>
);
export default ConfirmDeleteModal;
